import { gql, useQuery } from "@apollo/client";
import { CourseItem } from "../../types";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";
import { useCurrentUserClinic } from "./useCurrentUserClinic";

interface CoursesQueryResponse {
  data: CourseItem[];
  cursor: string;
}

const query = gql`
  query courses($clinicId: ID) {
    # TODO: handle pagination properly
    courses(clinicId: $clinicId, count: 200) {
      data {
        id
        slug
        name
        description
        status
        visibleToClinics {
          id
          name
        }
        sessions {
          cursor
          data {
            id
            name
          }
        }
      }
    }
  }
`;

const allCoursesQuery = gql`
  query allCourses {
    # TODO: handle pagination properly
    courses: allCourses(count: 200) {
      data {
        id
        slug
        name
        description
        status
        visibleToClinics {
          id
          name
        }
        sessions {
          cursor
          data {
            id
            name
          }
        }
      }
    }
  }
`;

export function useCourses() {
  const { featureFlags } = useFeatureFlags();
  const { clinic } = useCurrentUserClinic();

  const shouldUseAllCourses = featureFlags.ENABLE_MANAGE_COURSES;
  const clinicId = clinic?.id?.toString();

  return useQuery<{ courses: CoursesQueryResponse }, { clinicId?: string }>(
    shouldUseAllCourses ? allCoursesQuery : query,
    {
      variables: shouldUseAllCourses ? {} : { clinicId },
    },
  );
}
